export const locale = {
    lang: "es-ES",
    data: {
        HELP: {
            BUTTON_LABEL: "Ajuda"
        }
    }
};
